import React from "react";
import { MindspaceEventAgendaFragment } from "~/graphql/codegen/graphql";
import MindspaceEventAgendaItem from "./mindspace-event-agenda-item";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { Trans } from "@lingui/react/macro";

export default function MindspaceEventAgenda({
  agendaItems,
}: {
  agendaItems: MindspaceEventAgendaFragment[];
}) {
  const firstColItems =
    agendaItems.length < 5
      ? agendaItems
      : agendaItems.slice(0, Math.ceil(agendaItems.length / 2));
  const secondColItems = agendaItems.slice(
    firstColItems.length,
    agendaItems.length,
  );
  return (
    <div className="flex flex-col space-y-2">
      <h6 className="flex items-center">
        <ClipboardDocumentListIcon className="h-5 w-5 mr-1" />
        <span><Trans>Agenda</Trans></span>
      </h6>

      <div className="flex flex-col sm:flex-row sm:space-x-6">
        <div className="flex flex-col space-y-3 flex-1">
          {firstColItems.map((item) => (
            <MindspaceEventAgendaItem key={item.title} agendaItem={item} />
          ))}
        </div>
        {!!secondColItems.length && (
          <div className="flex flex-col space-y-3 flex-1">
            {secondColItems.map((item) => (
              <MindspaceEventAgendaItem key={item.title} agendaItem={item} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
